const EMAIL_VALIDATION_MESSAGE = 'Please enter a valid email';
const GENERIC_VALIDATION_MESSAGE = 'Required field';
const PASSWORD_VALIDATION_MESSAGE =
  'Must contain upercase, lowercase, numbers, a special character and be 8 characters long';
const PASSWORD_CONFIRM_VALIDATION_MESSAGE = 'Password must match';
const TOC_VALIDATION_MESSAGE = 'Please agree to our terms and conditions';
const TEL_VALIDATION_MESSAGE =
  'Invalid telephone number. Telephone number must start with international code. Ex: +447';

const COUNTRIES = [
  ['', 'Please Choose'],
  ['019078a056647196bb3a032b6d6100b7', 'United Kingdom']
];
export {
  EMAIL_VALIDATION_MESSAGE,
  GENERIC_VALIDATION_MESSAGE,
  PASSWORD_CONFIRM_VALIDATION_MESSAGE,
  PASSWORD_VALIDATION_MESSAGE,
  TOC_VALIDATION_MESSAGE,
  COUNTRIES,
  TEL_VALIDATION_MESSAGE
};
